import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import { AppConfig } from './../../../app.config';

@Injectable()
export class DeclarationsCollectivitesClientesService {
    private urlGetCollectivites: string = '';
    private urlListPartner: string = '';
    private urlSaveCollectivites: string = '';

    constructor(private http: HttpClient, private _appConfig: AppConfig) {
        this.urlGetCollectivites = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/GetCollectivites?idDett=';
        this.urlListPartner = _appConfig.getConfig().nPointDeclarations + '/utom/GetListPartnerByDecla?idDett=';
        this.urlSaveCollectivites = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/SaveCollectivites?idDett=';
    }

    getCollectivites(idDecla): Observable<any> {
        return this.http.get(this.urlGetCollectivites + idDecla)
            .catch(this.handleError);
    }

    getListPartner(idDett): Observable<any> {
        return this.http.get(this.urlListPartner + idDett)
            .catch(this.handleError);
    }

    saveCollectivites(declaId, collectivites): Observable<any> {
        return this.http.post(this.urlSaveCollectivites + declaId, collectivites)
            .catch(this.handleError);
    }

    private handleError(err: HttpErrorResponse) {
        let errMsg: string;
        if (err && (err.error instanceof Error)) {
            errMsg = `${err.status} - ${err.statusText || ''} ${err}`;
        } else if (err && err.error) {
            errMsg = (err.error.message ? err.error.message : err.error.toString());
        } else if (typeof err == 'string') {
            errMsg = err;
        }

        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/in/mes-declarations/services/declarations-collectivites-clientes.service.ts